import { Component, Input, OnInit } from '@angular/core';
import { StatusBadgeColourScheme } from '../../controls/status-badge/status-badge-constants';
import { materialSymbols } from '../../../shared/constants/material-symbols';
import { saLibraryPublicationTypes } from '../../../shared/constants/sa-library-constants';


@Component({
    selector: 'app-document-type-badge',
    templateUrl: './document-type-badge.component.html',
    styleUrl: './document-type-badge.component.scss',
    standalone: false
})
export class DocumentTypeBadgeComponent implements OnInit{
  public statusBadgeColourSchemeEnum = StatusBadgeColourScheme;

  @Input() documentType: string = '';
  @Input() name: string = '';
  colorScheme = StatusBadgeColourScheme.Blue2;
  iconName: string = materialSymbols.draft;

  ngOnInit(): void {
    this.colorScheme = this.getBadgeClass();
  }

  getBadgeClass(): StatusBadgeColourScheme {
    switch (this.documentType) {
      case saLibraryPublicationTypes.Standard:
        return  StatusBadgeColourScheme.saOrange;
      case saLibraryPublicationTypes.TechnicalSpecification:
      case saLibraryPublicationTypes.TechnicalReport:
      case saLibraryPublicationTypes.Handbook:
      case saLibraryPublicationTypes.InterimStandard:
        return  StatusBadgeColourScheme.Blue2;
      default:
        return StatusBadgeColourScheme.grey;
    }
  }
}
